import React from 'react';
import { CommandLineIcon } from '@heroicons/react/24/outline';

interface Props {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

const SqlEditor: React.FC<Props> = ({ value, onChange, placeholder, disabled }) => (
  <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
    <div className="flex items-center gap-2 px-5 py-3 bg-slate-50 border-b border-slate-200 text-sm font-medium text-slate-700">
      <CommandLineIcon className="w-4 h-4 text-slate-400" />
      SQL
    </div>
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder ?? 'Enter your SQL here. Multiple statements separated by ;'}
      disabled={disabled}
      spellCheck={false}
      className="w-full px-5 py-4 text-sm font-mono text-slate-800 placeholder-slate-400 border-none outline-none resize-y min-h-[240px] disabled:bg-slate-50"
      rows={12}
    />
  </div>
);

export default SqlEditor;
